<template>
	<div :key="customKey">
		<div class="demo-upload-list" v-for="item in fileTextComp.noticeUploadList">
			<template>
				<img v-if="item.endsWith('jpg') || item.endsWith('jpeg') || item.endsWith('png')" :src="api_domain + item" />
				<Icon
					v-else
					type="md-document"
					size="35"
					style="color: var(--burger-menu-btn); height: 100%;"
					class="d-flex align-items-center justify-content-center"
				/>
				<div class="demo-upload-list-cover">
					<Icon type="ios-eye-outline" @click.native="handleViewNotice(item)"></Icon>
					<Icon type="ios-trash-outline" @click.native="handleRemoveNotice(item)"></Icon>
				</div>
			</template>
		</div>
		<Upload
			ref="upload"
			:show-upload-list="false"
			:on-success="handleSuccessNotice"
			:format="['jpg', 'jpeg', 'png', 'doc', 'docx', 'pdf', 'txt', 'xlsx', 'xls']"
			:max-size="15360"
			:on-format-error="handleFormatErrorNotice"
			:on-exceeded-size="handleMaxSizeNotice"
			:before-upload="handleBeforeUploadNotice"
			multiple
			type="drag"
			:action="api_domain + 'file/upload/'"
			style="display: inline-block; width: 58px; margin-bottom: 15px;"
		>
			<div style="width: 58px; height: 58px; line-height: 58px;" class="d-flex justify-content-center align-items-center">
				<!-- <Icon type="ios-camera" size="20"></Icon> -->
				<Icon type="ios-cloud-upload" size="35" style="color: #3399ff;"></Icon>
			</div>
		</Upload>

		<Modal title="View Image" v-model="fileTextComp.visibleNoticeModal">
			<img
				v-if="
					fileTextComp.visibleNoticeModal &&
					(fileTextComp.imgName.endsWith('jpg') || fileTextComp.imgName.endsWith('jpeg') || fileTextComp.imgName.endsWith('png'))
				"
				:src="api_domain + fileTextComp.imgName"
				style="width: 100%;"
			/>
			<a v-else type="md-document" :href="api_domain + fileTextComp.imgName" target="_blank">
				{{ fileTextComp.imgName }}
			</a>
		</Modal>

		<Input v-model="fileTextComp.valueNotice" type="textarea" :rows="6" :name="customKey" placeholder="Enter something..." />
	</div>
</template>

<script>
	export default {
		name: 'CompetitionFileTextComponent',
		props: ['compFileText', 'customKey'],
		data() {
			return {
				fileTextComp: {},
			};
		},
		methods: {
			handleViewNotice(name) {
				console.log('name', name);
				this.fileTextComp.imgName = name;
				this.fileTextComp.visibleNoticeModal = true;
			},
			handleRemoveNotice(file) {
				// const fileList = this.$refs.upload.fileList;
				const fileList = [...this.fileTextComp.noticeUploadList];
				this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				this.fileTextComp.noticeUploadList.splice(fileList.indexOf(file), 1);
			},
			handleSuccessNotice(res, file) {
				file.url = file.response.path;
				file.name = file.response.originalname;
				this.fileTextComp.noticeUploadList.push(file.response.path);
			},
			handleFormatErrorNotice(file) {
				this.$Notice.warning({
					title: 'The file format is incorrect',
					desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.',
				});
			},
			handleMaxSizeNotice(file) {
				this.$Notice.warning({
					title: 'Exceeding file size limit',
					desc: 'File  ' + file.name + ' is too large, no more than 15M.',
				});
			},
			handleBeforeUploadNotice() {
				const check = this.fileTextComp.noticeUploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.',
					});
				}
				return check;
			},
		},
		mounted() {
			if (this.compFileText) {
				this.fileTextComp = this.compFileText;
				console.log('fileTextComp', this.fileTextComp);
			}
		},
	};
</script>

<style scoped>
	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
		margin-right: 4px;
	}
	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}
	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.6);
	}
	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}
	.demo-upload-list-cover i {
		color: #ffffff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/competitions/utils/CompetitionFileTextComponent.vue